import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import ProductPreferredIndicator from "~/features/productDetails/components/ProductPreferredIndicator";
import classNames from "classnames";
import { type IconSize } from "~/common/components/icon/IconSize";

interface Props extends BaseProductElementProps {
  reserveSpace?: boolean;
  tooltipSide?: "left" | "right" | "bottom";
  iconSize?: IconSize;
  noMargin?: boolean;
}

export const PreferredIndicator = (props: Props) => {
  const product = useProductContext(props);
  const isPreferred = product.preferred;
  const noMargin = props.noMargin ?? false;

  if (!isPreferred && !props.reserveSpace) {
    return null;
  }

  return (
    <ProductPreferredIndicator
      className={classNames(!noMargin && "icon-margin", !isPreferred && "v-hidden", props.className)}
      side={props.tooltipSide}
      iconSize={props.iconSize}
    />
  );
};
